import React from "react";
import { Route } from "react-router-dom";
import LaunchMissionControlPage from "pages/launch-mission-control/launch-mission-control.page";
import Users from "pages/Users/users.page";
import PoolDetail from "pages/Pools/Detail/pool-detail.page";
import DevicesPage from "pages/Devices/devices.page";
import PoolsPage from "pages/Pools/pools.page";
import { DeviceDetailPage } from "pages/Devices/Detail/device-detail.page";
import MapPage from "pages/Map/map.page";
import MultipleDevicesPage from "pages/add-multiple-devices/add-multiple-devices.page";
import { useAuth } from "hooks/useProvideAuth";
import PrivateRoute from "./components/PrivateRoute";
import "../theme/variables.css";
import OrgSelectionPage from "pages/org-selection/org-selection.page";

const AdminWebUserRoute = () => {
  const { isAdmin } = useAuth();

  return (
    <>
      <Route
        path="/devices"
        element={
          <PrivateRoute>
            <DevicesPage />
          </PrivateRoute>
        }
      />
      <Route
        path="/org-selection"
        element={
          <PrivateRoute orgSelection>
            <OrgSelectionPage />
          </PrivateRoute>
        }
      />
      <Route
        path="/devices/:sn"
        element={
          <PrivateRoute>
            <DeviceDetailPage />
          </PrivateRoute>
        }
      />

      {isAdmin && (
        <Route
          path="/users"
          element={
            <PrivateRoute>
              <Users />
            </PrivateRoute>
          }
        />
      )}

      <Route
        path="/pools"
        element={
          <PrivateRoute>
            <PoolsPage />
          </PrivateRoute>
        }
      />
      <Route
        path="/pools/:poolId"
        element={
          <PrivateRoute>
            <PoolDetail />
          </PrivateRoute>
        }
      />

      <Route path="/map">
        <Route
          path=":sn"
          element={
            <PrivateRoute>
              <MapPage />
            </PrivateRoute>
          }
        />
        <Route
          path=""
          element={
            <PrivateRoute>
              <MapPage />
            </PrivateRoute>
          }
        />
      </Route>
      <Route
        path="/launch-mission-control/:sn"
        element={
          <PrivateRoute>
            <LaunchMissionControlPage />
          </PrivateRoute>
        }
      />
      <Route
        path="/add-multiple-devices"
        element={
          <PrivateRoute>
            <MultipleDevicesPage />
          </PrivateRoute>
        }
      />
    </>
  );
};
export default AdminWebUserRoute;
